
let PhotoEditor = (function () {

    let configurator = null;

    function init()
    {
        const config = JSON.parse(document.getElementById('photo-editor-config').textContent);

        let product_id = config.upme_product_id;
        let ext_gallery_id = config.upme_ext_gallery_id;
        let texture_file_url = config.texture_file_url;
        let product_configurator_api_result_json_base64 = config.upme_product_configurator_api_result_json_base64;

        let product_configurator_api_result_json = atob(product_configurator_api_result_json_base64);

        let product_configurator_api_result_object = JSON.parse(product_configurator_api_result_json);

        product_configurator_api_result_object._embedded.photos[ext_gallery_id].thumbnail.large.url = texture_file_url;

        initMobile();


        configurator = new UpMeConfigurator();

        configurator.setApiResult(product_configurator_api_result_object);
        configurator.setUpdatePriceFunction(ProductPage.updatePrice)

        configurator.setProductId( product_id );
        configurator.setPhotoId( ext_gallery_id );

        configurator.generateForm().then( () => {
            initScaling();
            //initSliders();
            //enableSimilarPhotosEvents();
            //initDPILabel();
            initPanelsAmount();
            initEditor(configurator.getEditor());

        });


        function initEditor(editor)
        {

            if(editor)
            {
                editor.settings.setSafeZoneColor( '#ff2e17ff' );
                editor.settings.setGroupBorderColor( '#389dd6ff' );
                editor.settings.setGroupBorderDash( [] );
                editor.settings.setSafeZoneColor( '#000000ff' );


                if( editor instanceof ClickToWallArt )
                {



                    editor.setOutsideDimensionsFont("16px bryant");
                    //editor.settings.toggleDisplayRuler( true );
                    //editor.settings.toggleDisplayFormsDimensions( true );
                    transferInputEvents("width");
                    transferInputEvents("height");

                    editor.setMaxSize(ProductPage.getWidthElement().max, ProductPage.getHeightElement().max);

                    ProductPage.updateTilingSettings();

                    initDisableEditorEvents();

                    let upme_material_container = document.getElementById("upme-material-container");
                    if(upme_material_container)
                        Custom.hideElement(upme_material_container);

                }


            }
        }

        function transferInputEvents(kind) {

            let sourceSelector = '#upme-custom-format-container input[name="' + kind + '"]';
            const sourceInput = document.querySelector(sourceSelector);
            let targetDataToggle = "ctw-" + kind;
            const targetInput = document.querySelector(`input[data-toggle="${targetDataToggle}"]`);

            if (!sourceInput || !targetInput) {
                console.log(`Nie znaleziono inputów: ${sourceSelector} -> ${targetDataToggle}`);
                return;
            }

            targetInput.min = sourceInput.min;
            targetInput.dataEditorMax = sourceInput.max;


            document.getElementById("disabled_editor_text").innerHTML = document.getElementById("disabled_editor_text").innerHTML.replace("%" + kind + "%", targetInput.dataEditorMax);

            // Przekaż eventy change
            targetInput.addEventListener('change', function() {
                //sourceInput.value = this.value;
                Custom.dispatchEvent(sourceInput, 'change');
            });

            // Usuń oryginalny input
            sourceInput.remove();
        }


        function initScaling()
        {
            function initializeRangeSlider() {
                const rangeSlider = document.getElementById('ctw-background-scale');
                const valueDisplay = document.getElementById('ctw-background-scale-value-tooltip');

                if (rangeSlider && valueDisplay) {
                    // Aktualizuj wartość pod suwakiem
                    function updateValueDisplay() {
                        const value = rangeSlider.value;
                        valueDisplay.textContent = value + '%';
                    }

                    // Event listeners
                    rangeSlider.addEventListener('input', updateValueDisplay);
                    rangeSlider.addEventListener('change', updateValueDisplay);

                    // Inicjalna wartość
                    updateValueDisplay();

                } else {
                    // Fallback - spróbuj ze starym tooltipem
                    const tooltip = document.getElementById('ctw-background-scale-value-tooltip');
                    if (rangeSlider && tooltip) {

                        rangeSlider.addEventListener('input', () => {
                            tooltip.textContent = rangeSlider.value + '%';
                        });
                    }
                }
            }

            // Inicjalizuj suwak po załadowaniu DOM lub gdy edytor się załaduje
            const sliderInitTimer = setInterval(() => {
                if (document.getElementById('ctw-background-scale')) {
                    initializeRangeSlider();
                    clearInterval(sliderInitTimer);
                }
            }, 500);

            // Cleanup po 10 sekundach jeśli suwak się nie pojawi
            setTimeout(() => {
                clearInterval(sliderInitTimer);
            }, 10000);

        }

        function initPanelsAmount()
        {
            let editor = configurator.getEditor();
            if( !editor || !(editor instanceof ClickToPanel))
                return;

            editor.on( 'formEnabled', updatePanelsAmount );
            editor.on( 'formDisabled', updatePanelsAmount );

            let rolls_number_quantity_input = document.querySelector('input[name="product_quantity"]');

            rolls_number_quantity_input.readOnly = true;

            updatePanelsAmount();

            function updatePanelsAmount()
            {
                let amount = 0;
                for( let object of configurator.getEditor().getClickToEditor().getAllObjects() )
                    if( !object.isGroup() && object.isEnabled() )
                        ++amount;

                rolls_number_quantity_input.value = amount;
                Custom.dispatchEvent(rolls_number_quantity_input, 'change');


            }
        }

        function toggleEditor()
        {

            if(isEditorEnabled())
                enableEditor();
            else
                disableEditor();

            ProductPage.updatePersonalizationInfo();

        }

        function initDisableEditorEvents() {

            let widthElement = ProductPage.getWidthElement();

            if (widthElement) {
                widthElement.addEventListener('change', toggleEditor);
                widthElement.addEventListener('change', ProductPage.updatePersonalizationInfo);
            }

            let heightElement = ProductPage.getHeightElement();

            if (heightElement) {
                heightElement.addEventListener('change', toggleEditor);
                heightElement.addEventListener('change', ProductPage.updatePersonalizationInfo);
            }

            let scaleElement = ProductPage.getScaleElement();
            if (scaleElement) {
                scaleElement.addEventListener('change', toggleEditor);
                scaleElement.addEventListener('change', ProductPage.updatePersonalizationInfo);
            }

            let personalization_shape_checkbox = ProductPage.getPersonalizationShapeCheckboxElement();
            if(personalization_shape_checkbox)
            {
                personalization_shape_checkbox.addEventListener('change', toggleEditor);
            }

            let personalization_pattern_checkbox = ProductPage.getPersonalizationPatternCheckboxElement();
            if(personalization_pattern_checkbox)
            {
                personalization_pattern_checkbox.addEventListener('change', toggleEditor);
            }

        }
    }

    function getConfigurator()
    {
        return configurator;
    }

    function getEditor()
    {
        return getConfigurator().getEditor();
    }

    function isPanelEditor()
    {
        let editor = getEditor();

        if( editor instanceof ClickToPanel )
            return true;

        return false;
    }

    /**
     * czy wprowadzone przez użytkownia wymiary są większe od zalecanych
     * @returns {boolean}
     */
    function areDimensionsOverRecommended()
    {
        let checkDimension = function(_dimension_element) {
            const maxValue = parseFloat(_dimension_element.dataEditorMax);
            const currentValue = parseFloat(_dimension_element.value);
            return (currentValue > maxValue);
        }

        let are_dimensions_over_recommended = false;

        let widthElement = ProductPage.getWidthElement();
        if (widthElement) {
            are_dimensions_over_recommended = are_dimensions_over_recommended || checkDimension(widthElement);
        }

        let heightElement = ProductPage.getHeightElement();

        if (heightElement) {
            are_dimensions_over_recommended = are_dimensions_over_recommended || checkDimension(heightElement);
        }

        return are_dimensions_over_recommended;
    }

    function isScaleOverRecommended()
    {
        let current_scale = getEditor().getScale();
        let min_scale = getEditor().getMinScale();
        let max_scale = getEditor().getMaxScale();

        return (current_scale < min_scale || current_scale > max_scale);

    }

    /**
     * czy edytor jest dostępny
     * - zastosowane personalizacje mogą powodować konieczność jego wyłączenia
     *
     * @returns {boolean}
     */
    function isEditorEnabled()
    {
        let is_editor_enabled = true;

        let checkPersonalization = function(__personalization_element) {
            return !__personalization_element.checked;
        }

        is_editor_enabled = is_editor_enabled && !areDimensionsOverRecommended();

        let personalization_shape_checkbox = ProductPage.getPersonalizationShapeCheckboxElement();
        if(personalization_shape_checkbox)
        {
            is_editor_enabled = is_editor_enabled && checkPersonalization(personalization_shape_checkbox);
        }

        let personalization_pattern_checkbox = ProductPage.getPersonalizationPatternCheckboxElement();
        if(personalization_pattern_checkbox)
        {
            is_editor_enabled = is_editor_enabled && checkPersonalization(personalization_pattern_checkbox);
        }

        if(isScaleOverRecommended())
            is_editor_enabled = false;

        return is_editor_enabled;
    }

    function setTilingSettings(roll_width_value, roll_width_unit, min_roll_width_value, min_roll_width_unit, overlap_h_value, overlap_h_unit)
    {
        let settings = {
            roll_width: roll_width_value ? convertToUnit(roll_width_value, roll_width_unit, 'm') : 0,
            min_roll_width: min_roll_width_value ? convertToUnit(min_roll_width_value, min_roll_width_unit, 'm') : 0,
            overlap_h: overlap_h_value ? convertToUnit(overlap_h_value, overlap_h_unit, 'm') : 0,
            stroke_color: 'white'
        };

        getEditor().getClickToEditor().setTilingSettings(settings);
        getEditor().getClickToEditor().redrawNow();
    }

    function convertToUnit(value, fromUnit, toUnit) {


        // Konwersja do cm jako jednostki bazowej
        const toCm = {
            'cm': 1,
            'mm': 0.1,
            'm': 100,
            'in': 2.54
        };

        // Konwertuj do cm, potem do docelowej jednostki
        const valueInCm = value * toCm[fromUnit];
        const result = valueInCm / toCm[toUnit];

        return result;
    }

    function toggleEditor(enabled) {
        const mode = enabled ? 'enabled' : 'disabled';

        document.querySelectorAll('[data-visible-when-editor]').forEach(el => {
            el.classList.toggle('hidden', el.dataset.visibleWhenEditor !== mode);
        });

        document.querySelectorAll('[data-disabled-when-editor]').forEach(el => {
            if(el.dataset.disabledWhenEditor === mode)
                el.disabled = true;
            else
                el.disabled = false;
        });
    }



    function enableEditor()
    {
        toggleEditor(true);
        getEditor().getClickToEditor().redrawNow();
        setTimeout(function(){getEditor().correct();}, 10);

    }

    function disableEditor()
    {
        toggleEditor(false);
    }

    function getScaleValue()
    {
        return getEditor().getScale();
    }

    function getSimplePreview()
    {
        let editor = getEditor();

        let canvas = editor.exportPreviews(
            'canvas',
            {}
        ).preview;

        canvas.style.maxWidth = '100%';
        canvas.style.maxHeight = '50vh';

        return canvas;
    }

    function getDetailedPreview()
    {

        let editor = getEditor();

        let settings = JSON.parse( JSON.stringify( configurator.__get_orm().mod_product.settings.detailed_preview ?? {} ));
        if( configurator.__get_orm().col_material.selected && configurator.__get_orm().col_material.selected.settings )
            for( let key of Object.keys( configurator.__get_orm().col_material.selected.settings ))
                settings[key] = configurator.__get_orm().col_material.selected.settings[key];
        if( !settings['enable'] )
            settings = {};


        settings.group_border_color = '#389dd6ff';
        settings.safe_zone_color = '#ff2e17ff';
        
        let canvas = editor.exportPreviews(
            'canvas',
            settings
        ).preview;

        canvas.style.maxWidth = '100%';
        canvas.style.maxHeight = '50vh';

        return canvas;
    }

    function initMobile()
    {

        let photo_editor_mobile_test = document.querySelector(".photo_editor_mobile_test");
        let photo_editor_mobile = document.querySelector(".photo_editor_mobile");
        let photo_editor_desktop = document.querySelector(".photo_editor_desktop");

        if(photo_editor_mobile_test && photo_editor_mobile && photo_editor_desktop)
            if(Custom.isElementVisible(photo_editor_mobile_test))
            {
                photo_editor_mobile.replaceWith(photo_editor_desktop);

                let photo_editor_scale_control_mobile = document.querySelector(".photo_editor_scale_control_mobile");
                let photo_editor_scale_control_desktop = document.querySelector(".photo_editor_scale_control_desktop");

                if(photo_editor_scale_control_mobile && photo_editor_scale_control_desktop)
                    photo_editor_scale_control_mobile.replaceWith(photo_editor_scale_control_desktop);

                let thumbnails_slider_desktop = document.querySelector(".thumbnails-slider");
                let thumbnails_slider_mobile = document.querySelector(".thumbnails_slider_mobile");

                if(thumbnails_slider_desktop && thumbnails_slider_mobile)
                    thumbnails_slider_mobile.replaceWith(thumbnails_slider_desktop);

            }

    }

    return {
        init: init,
        getConfigurator: getConfigurator,
        getEditor: getEditor,
        setTilingSettings: setTilingSettings,
        isEditorEnabled: isEditorEnabled,
        isPanelEditor: isPanelEditor,
        getScaleValue: getScaleValue,
        isScaleOverRecommended: isScaleOverRecommended,
        areDimensionsOverRecommended: areDimensionsOverRecommended,
        getSimplePreview: getSimplePreview,
        getDetailedPreview: getDetailedPreview,
    }
})();

document.addEventListener('DOMContentLoaded', function() {
    PhotoEditor.init();
});